import api from './xano';

export type SignupPayload = {
  email: string;
  password: string;
  name: string;
  role: 'admin' | 'student';
  phone: string;
  parentPhone: string;
  academyname: string;
  uniqueKey: string;
  location: string;
  schoolName: string;
  schoolCode: string;
  class: string;
  memo: string;
};

export type AuthUser = Record<string, unknown>;
export type UserRole = 'admin' | 'student' | 'unknown';

export const getAuthTokenFromResponse = (payload: any): string => {
  const token =
    payload?.token ||
    payload?.authToken ||
    payload?.access_token ||
    payload?.accessToken ||
    payload?.data?.token ||
    payload?.data?.authToken ||
    payload?.data?.access_token ||
    payload?.data?.accessToken;

  return typeof token === 'string' ? token : '';
};

export const normalizeMePayload = (payload: any): AuthUser => {
  if (payload?.user && typeof payload.user === 'object') {
    return payload.user as AuthUser;
  }

  if (payload?.data && typeof payload.data === 'object') {
    return payload.data as AuthUser;
  }

  return (payload || {}) as AuthUser;
};

const normalizeStringValue = (value: unknown): string => {
  return typeof value === 'string' ? value.trim() : '';
};

export const getUserRole = (user: AuthUser | null | undefined): UserRole => {
  const roleValue = normalizeStringValue(user?.role || user?.userRole || user?.memberRole).toLowerCase();

  if (roleValue === 'admin' || roleValue === 'administrator') {
    return 'admin';
  }

  if (roleValue === 'student') {
    return 'student';
  }

  return 'unknown';
};

export const getUserAcademyName = (user: AuthUser | null | undefined): string => {
  return normalizeStringValue(user?.academyname || user?.academyName || user?.academy);
};

export const getUserDisplayName = (user: AuthUser | null | undefined): string => {
  return (
    normalizeStringValue(user?.name) ||
    normalizeStringValue(user?.username) ||
    normalizeStringValue(user?.email) ||
    normalizeStringValue(user?.id) ||
    '사용자'
  );
};

export const getHomePathForUser = (user: AuthUser | null | undefined): string => {
  return getUserRole(user) === 'admin' ? '/admin/home' : '/home';
};

export const authAPI = {
  login: (email: string, password: string) =>
    api.post('/auth/login', { email, password }),

  signup: (payload: SignupPayload) => api.post('/auth/signup', payload),

  getMe: () => api.get('/auth/me'),
};
